import type * as Types from '../generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetEventByNameQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
  userId: Types.Scalars['String'];
}>;

export type GetEventByNameQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    firebaseId: string;
    website: string;
    eventMatch?: {
      __typename?: 'EventMatch';
      id: string;
      showcase: Array<{
        __typename?: 'Match';
        id: string;
        testimony?: { __typename?: 'Testimony'; id: string; content: string } | null;
        vendor: {
          __typename?: 'Vendor';
          id: string;
          name: string;
          vendorUserByUserId?: { __typename?: 'VendorUser'; id: string } | null;
          type: Array<{ __typename?: 'VendorType'; id: string; display: string }>;
          photo?: { __typename?: 'Photo'; id: string; url: string } | null;
        };
      }>;
    } | null;
    info: {
      __typename?: 'EventInfo';
      id: string;
      ownerFirstName?: string | null;
      ownerLastName?: string | null;
      fianceeFirstName?: string | null;
      fianceeLastName?: string | null;
      eventDisplayName?: string | null;
      eventType: Types.EventType;
      location?: string | null;
      greeting?: string | null;
      timezone?: string | null;
      locationInfo?: {
        __typename?: 'EventLocation';
        id?: string | null;
        placeId?: string | null;
        name?: string | null;
        city?: string | null;
        state?: string | null;
        country?: string | null;
        address1?: string | null;
        address2?: string | null;
        latitude?: number | null;
        longitude?: number | null;
      } | null;
      tentativeDate?: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number } | null;
      finalizedDate?: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number; timeString: string } | null;
      dateV0918?: { __typename?: 'Date'; milliseconds: number } | null;
    };
    firebaseCreateAt?: { __typename?: 'Date'; milliseconds: number } | null;
  } | null;
};

export type GetEventWithChecklistByNameQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetEventWithChecklistByNameQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    firebaseId: string;
    website: string;
    info: {
      __typename?: 'EventInfo';
      id: string;
      ownerFirstName?: string | null;
      ownerLastName?: string | null;
      fianceeFirstName?: string | null;
      fianceeLastName?: string | null;
      eventDisplayName?: string | null;
      eventType: Types.EventType;
      location?: string | null;
      greeting?: string | null;
      timezone?: string | null;
      locationInfo?: {
        __typename?: 'EventLocation';
        id?: string | null;
        placeId?: string | null;
        name?: string | null;
        city?: string | null;
        state?: string | null;
        country?: string | null;
        address1?: string | null;
        address2?: string | null;
        latitude?: number | null;
        longitude?: number | null;
      } | null;
      tentativeDate?: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number } | null;
      finalizedDate?: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number; timeString: string } | null;
      dateV0918?: { __typename?: 'Date'; milliseconds: number } | null;
    };
    firebaseCreateAt?: { __typename?: 'Date'; milliseconds: number } | null;
  } | null;
};

export type GetEventInfoByNameQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetEventInfoByNameQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    firebaseId: string;
    website: string;
    productVerticals?: {
      __typename?: 'EventProductVerticals';
      id: string;
      optOutOfGuestList?: boolean | null;
      optOutOfInvites?: boolean | null;
      optOutOfRegistry?: boolean | null;
      optOutOfWebsite?: boolean | null;
    } | null;
    info: {
      __typename?: 'EventInfo';
      id: string;
      ownerFirstName?: string | null;
      ownerLastName?: string | null;
      fianceeFirstName?: string | null;
      fianceeLastName?: string | null;
      eventDisplayName?: string | null;
      eventType: Types.EventType;
      location?: string | null;
      greeting?: string | null;
      timezone?: string | null;
      locationInfo?: {
        __typename?: 'EventLocation';
        id?: string | null;
        placeId?: string | null;
        name?: string | null;
        city?: string | null;
        state?: string | null;
        country?: string | null;
        address1?: string | null;
        address2?: string | null;
        latitude?: number | null;
        longitude?: number | null;
      } | null;
      tentativeDate?: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number } | null;
      finalizedDate?: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number; timeString: string } | null;
      dateV0918?: { __typename?: 'Date'; milliseconds: number } | null;
    };
    firebaseCreateAt?: { __typename?: 'Date'; milliseconds: number } | null;
  } | null;
};

export type GetEventByNameForDomainQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetEventByNameForDomainQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    website: string;
    info: { __typename?: 'EventInfo'; id: string; ownerFirstName?: string | null; fianceeFirstName?: string | null };
    domain?: { __typename?: 'EventDomain'; id: string; domainName: string } | null;
  } | null;
};

export type GetEventByNameForIdeabookQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetEventByNameForIdeabookQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    firebaseId: string;
    website: string;
    eventMatch?: {
      __typename?: 'EventMatch';
      id: string;
      vendorState?: Types.VendorState | null;
      collections: Array<{
        __typename?: 'Collection';
        id: string;
        description?: string | null;
        name: string;
        itemCount: number;
        items: {
          __typename?: 'CollectionItemsConnection';
          edges: Array<{
            __typename?: 'CollectionItemsEdge';
            node: {
              __typename?: 'CollectionItem';
              id: string;
              description?: string | null;
              photo?: {
                __typename?: 'Photo';
                likedByCurrentUser: boolean;
                id: string;
                url: string;
                width: number;
                height: number;
                blurHash?: string | null;
                altTag?: string | null;
                layout: { __typename?: 'PhotoLayout'; alignX: string; alignY: string };
                transform?: { __typename?: 'PhotoTransform'; x?: number | null; y?: number | null } | null;
              } | null;
              video?: { __typename?: 'Video'; id: string; url: string; title?: string | null } | null;
            };
          }>;
        };
      }>;
    } | null;
    info: {
      __typename?: 'EventInfo';
      id: string;
      ownerFirstName?: string | null;
      ownerLastName?: string | null;
      fianceeFirstName?: string | null;
      fianceeLastName?: string | null;
      eventDisplayName?: string | null;
      eventType: Types.EventType;
      location?: string | null;
      greeting?: string | null;
      timezone?: string | null;
      locationInfo?: {
        __typename?: 'EventLocation';
        id?: string | null;
        placeId?: string | null;
        name?: string | null;
        city?: string | null;
        state?: string | null;
        country?: string | null;
        address1?: string | null;
        address2?: string | null;
        latitude?: number | null;
        longitude?: number | null;
      } | null;
      tentativeDate?: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number } | null;
      finalizedDate?: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number; timeString: string } | null;
      dateV0918?: { __typename?: 'Date'; milliseconds: number } | null;
    };
    firebaseCreateAt?: { __typename?: 'Date'; milliseconds: number } | null;
  } | null;
};

export type CheckCanAccessPageQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
  type: Types.EventPageType;
}>;

export type CheckCanAccessPageQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    firebaseId: string;
    firebaseCreateAt?: { __typename?: 'Date'; milliseconds: number } | null;
    activeSession: { __typename?: 'EventSession'; id: string; canAccessPage: boolean };
    pageInfo?: { __typename?: 'EventPageInfo'; id: string; private: boolean; disabled: boolean; page: { __typename?: 'EventPage'; id: string; pageTitle: string } } | null;
  } | null;
};

export type GetEventByEventIdForEventRedirectQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type GetEventByEventIdForEventRedirectQuery = { __typename?: 'Query'; eventById?: { __typename?: 'Event'; id: string; firebaseId: string; website: string } | null };

export type GetEventForAdminMenuQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetEventForAdminMenuQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    info: {
      __typename?: 'EventInfo';
      id: string;
      ownerFirstName?: string | null;
      ownerLastName?: string | null;
      fianceeFirstName?: string | null;
      fianceeLastName?: string | null;
      eventDisplayName?: string | null;
      eventType: Types.EventType;
      location?: string | null;
      greeting?: string | null;
      timezone?: string | null;
      locationInfo?: {
        __typename?: 'EventLocation';
        id?: string | null;
        placeId?: string | null;
        name?: string | null;
        city?: string | null;
        state?: string | null;
        country?: string | null;
        address1?: string | null;
        address2?: string | null;
        latitude?: number | null;
        longitude?: number | null;
      } | null;
      tentativeDate?: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number } | null;
      finalizedDate?: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number; timeString: string } | null;
      dateV0918?: { __typename?: 'Date'; milliseconds: number } | null;
    };
    photo?: { __typename?: 'Photo'; id: string; url: string; altTag?: string | null } | null;
  } | null;
  me?: { __typename?: 'User'; id: string; avatar?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
};

export type GetEventFeatureFlagsByEventHandleQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetEventFeatureFlagsByEventHandleQuery = {
  __typename?: 'Query';
  eventByName?: { __typename?: 'Event'; id: string; featureFlags?: Array<string | null> | null } | null;
};

export type GetEventForAdminMenuV2QueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetEventForAdminMenuV2Query = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    firebaseCreateAt?: { __typename?: 'Date'; milliseconds: number } | null;
    info: {
      __typename?: 'EventInfo';
      eventPassword?: string | null;
      id: string;
      ownerFirstName?: string | null;
      ownerLastName?: string | null;
      fianceeFirstName?: string | null;
      fianceeLastName?: string | null;
      eventDisplayName?: string | null;
      eventType: Types.EventType;
      location?: string | null;
      greeting?: string | null;
      timezone?: string | null;
      locationInfo?: {
        __typename?: 'EventLocation';
        id?: string | null;
        placeId?: string | null;
        name?: string | null;
        city?: string | null;
        state?: string | null;
        country?: string | null;
        address1?: string | null;
        address2?: string | null;
        latitude?: number | null;
        longitude?: number | null;
      } | null;
      tentativeDate?: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number } | null;
      finalizedDate?: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number; timeString: string } | null;
      dateV0918?: { __typename?: 'Date'; milliseconds: number } | null;
    };
    eventOnboarding?: { __typename?: 'EventOnboarding'; shouldShowOnboardingSurvey?: boolean | null } | null;
    productVerticals?: {
      __typename?: 'EventProductVerticals';
      id: string;
      optOutOfGuestList?: boolean | null;
      optOutOfInvites?: boolean | null;
      optOutOfRegistry?: boolean | null;
      optOutOfWebsite?: boolean | null;
    } | null;
    pages: Array<{
      __typename?: 'EventPage';
      visibility: Types.EventPageVisibility;
      isPageContainer: boolean;
      pageSlug: string;
      id: string;
      type: Types.EventPageType;
      pageTitle: string;
      createdAt: { __typename?: 'Date'; timestamp: any };
      photo?: { __typename?: 'Photo'; id: string; url: string } | null;
    }>;
    photo?: { __typename?: 'Photo'; id: string; url: string; altTag?: string | null } | null;
    recommendation: {
      __typename?: 'RecommendEvent';
      registryOnboardingSurvey: { __typename?: 'RecommendRegistryOnboardingSurveyResults'; id: string; lastUpdatedAt?: { __typename?: 'Date'; dateString: string } | null };
    };
    checklist?: { __typename?: 'EventChecklist'; id: string } | null;
    eventDesign?: {
      __typename?: 'EventDesign';
      id: string;
      font: { __typename?: 'Font'; id: string; fontFamily: string };
      activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings'; dataJSON: any; schemaURL: string; websiteLayout: string; id: string } | null;
    } | null;
  } | null;
  me?: { __typename?: 'User'; id: string; avatar?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
};

export type SaveEventProductVerticalsMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  payload: Types.UpdateEventProductVerticalsPayload;
}>;

export type SaveEventProductVerticalsMutation = {
  __typename?: 'Mutation';
  saveEventProductVerticals: {
    __typename?: 'EventProductVerticals';
    id: string;
    optOutOfGuestList?: boolean | null;
    optOutOfInvites?: boolean | null;
    optOutOfRegistry?: boolean | null;
    optOutOfWebsite?: boolean | null;
  };
};

export type GetEventAdminsAndInviteesQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetEventAdminsAndInviteesQuery = {
  __typename?: 'Query';
  eventById?: {
    __typename?: 'Event';
    id: string;
    eventUsers: Array<{
      __typename?: 'EventUser';
      id: string;
      auth0Id: string;
      status: Types.EventUserStatus;
      user: { __typename?: 'User'; id: string; firstName?: string | null; lastName?: string | null; email?: string | null; emailIsVerified: boolean };
    }>;
  } | null;
  eventAdminInvites?: Array<{ __typename?: 'EventAdminInvite'; emailId: string; id: string; name: string; status?: string | null } | null> | null;
};

export type GetEventHandleAvailabilityQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  websiteHandle: Types.Scalars['String'];
}>;

export type GetEventHandleAvailabilityQuery = { __typename?: 'Query'; isWebsiteHandleAvailable: boolean };

export type GetUrlVerificationStatusQueryVariables = Types.Exact<{
  url: Types.Scalars['String'];
}>;

export type GetUrlVerificationStatusQuery = { __typename?: 'Query'; verifyUrl?: Types.UrlVerificationStatus | null };

export type FindDefaultThingsToDoPageQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type FindDefaultThingsToDoPageQuery = { __typename?: 'Query'; findDefaultThingsToDoPage?: { __typename?: 'PageContainer'; id: string; slug: string } | null };

export const GetEventByNameDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventByName' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventFragment' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'eventMatch' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'showcase' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'testimony' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'vendor' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'vendorUserByUserId' },
                                          arguments: [
                                            { kind: 'Argument', name: { kind: 'Name', value: 'userId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } } },
                                          ],
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                                        },
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventShowcaseVendor' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventFragmentCommon' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'info' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventInfoFragment' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFragmentCommon' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firebaseId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firebaseCreateAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventInfoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fianceeLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'greeting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tentativeDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'finalizedDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'timeString' },
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'timeFormat' }, value: { kind: 'EnumValue', value: 'time' } }],
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dateV0918' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventShowcaseVendor' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Vendor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventByNameQuery__
 *
 * To run a query within a React component, call `useGetEventByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByNameQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetEventByNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventByNameQuery, GetEventByNameQueryVariables>) {
  return ApolloReactHooks.useQuery<GetEventByNameQuery, GetEventByNameQueryVariables>(GetEventByNameDocument, baseOptions);
}
export function useGetEventByNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventByNameQuery, GetEventByNameQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetEventByNameQuery, GetEventByNameQueryVariables>(GetEventByNameDocument, baseOptions);
}
export type GetEventByNameQueryHookResult = ReturnType<typeof useGetEventByNameQuery>;
export type GetEventByNameLazyQueryHookResult = ReturnType<typeof useGetEventByNameLazyQuery>;
export type GetEventByNameQueryResult = Apollo.QueryResult<GetEventByNameQuery, GetEventByNameQueryVariables>;
export const GetEventWithChecklistByNameDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventWithChecklistByName' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventFragment' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventFragmentCommon' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'info' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventInfoFragment' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFragmentCommon' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firebaseId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firebaseCreateAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventInfoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fianceeLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'greeting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tentativeDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'finalizedDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'timeString' },
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'timeFormat' }, value: { kind: 'EnumValue', value: 'time' } }],
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dateV0918' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventWithChecklistByNameQuery__
 *
 * To run a query within a React component, call `useGetEventWithChecklistByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventWithChecklistByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventWithChecklistByNameQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventWithChecklistByNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventWithChecklistByNameQuery, GetEventWithChecklistByNameQueryVariables>) {
  return ApolloReactHooks.useQuery<GetEventWithChecklistByNameQuery, GetEventWithChecklistByNameQueryVariables>(GetEventWithChecklistByNameDocument, baseOptions);
}
export function useGetEventWithChecklistByNameLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventWithChecklistByNameQuery, GetEventWithChecklistByNameQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetEventWithChecklistByNameQuery, GetEventWithChecklistByNameQueryVariables>(GetEventWithChecklistByNameDocument, baseOptions);
}
export type GetEventWithChecklistByNameQueryHookResult = ReturnType<typeof useGetEventWithChecklistByNameQuery>;
export type GetEventWithChecklistByNameLazyQueryHookResult = ReturnType<typeof useGetEventWithChecklistByNameLazyQuery>;
export type GetEventWithChecklistByNameQueryResult = Apollo.QueryResult<GetEventWithChecklistByNameQuery, GetEventWithChecklistByNameQueryVariables>;
export const GetEventInfoByNameDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventInfoByName' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventFragmentForAdmin' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFragmentCommon' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firebaseId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firebaseCreateAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventInfoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fianceeLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'greeting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tentativeDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'finalizedDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'timeString' },
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'timeFormat' }, value: { kind: 'EnumValue', value: 'time' } }],
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dateV0918' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFragmentForAdmin' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventFragmentCommon' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productVerticals' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfGuestList' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfInvites' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfRegistry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfWebsite' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'info' },
            name: { kind: 'Name', value: 'info' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventInfoFragment' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventInfoByNameQuery__
 *
 * To run a query within a React component, call `useGetEventInfoByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventInfoByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventInfoByNameQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventInfoByNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventInfoByNameQuery, GetEventInfoByNameQueryVariables>) {
  return ApolloReactHooks.useQuery<GetEventInfoByNameQuery, GetEventInfoByNameQueryVariables>(GetEventInfoByNameDocument, baseOptions);
}
export function useGetEventInfoByNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventInfoByNameQuery, GetEventInfoByNameQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetEventInfoByNameQuery, GetEventInfoByNameQueryVariables>(GetEventInfoByNameDocument, baseOptions);
}
export type GetEventInfoByNameQueryHookResult = ReturnType<typeof useGetEventInfoByNameQuery>;
export type GetEventInfoByNameLazyQueryHookResult = ReturnType<typeof useGetEventInfoByNameLazyQuery>;
export type GetEventInfoByNameQueryResult = Apollo.QueryResult<GetEventInfoByNameQuery, GetEventInfoByNameQueryVariables>;
export const GetEventByNameForDomainDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventByNameForDomain' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'domain' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'domainName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventByNameForDomainQuery__
 *
 * To run a query within a React component, call `useGetEventByNameForDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByNameForDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByNameForDomainQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventByNameForDomainQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventByNameForDomainQuery, GetEventByNameForDomainQueryVariables>) {
  return ApolloReactHooks.useQuery<GetEventByNameForDomainQuery, GetEventByNameForDomainQueryVariables>(GetEventByNameForDomainDocument, baseOptions);
}
export function useGetEventByNameForDomainLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventByNameForDomainQuery, GetEventByNameForDomainQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetEventByNameForDomainQuery, GetEventByNameForDomainQueryVariables>(GetEventByNameForDomainDocument, baseOptions);
}
export type GetEventByNameForDomainQueryHookResult = ReturnType<typeof useGetEventByNameForDomainQuery>;
export type GetEventByNameForDomainLazyQueryHookResult = ReturnType<typeof useGetEventByNameForDomainLazyQuery>;
export type GetEventByNameForDomainQueryResult = Apollo.QueryResult<GetEventByNameForDomainQuery, GetEventByNameForDomainQueryVariables>;
export const GetEventByNameForIdeabookDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventByNameForIdeabook' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventFragment' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'eventMatch' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventMatch' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventFragmentCommon' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'info' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventInfoFragment' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFragmentCommon' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firebaseId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firebaseCreateAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventInfoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fianceeLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'greeting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tentativeDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'finalizedDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'timeString' },
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'timeFormat' }, value: { kind: 'EnumValue', value: 'time' } }],
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dateV0918' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventMatch' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventMatch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vendorState' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collections' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Collection' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Collection' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Collection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photo' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LikedPhoto' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'video' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Video' } }] },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LikedPhoto' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Photo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'likedByCurrentUser' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Photo' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurHash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'altTag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoLayout' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transform' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoTransform' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoLayout' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhotoLayout' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoTransform' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhotoTransform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Video' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Video' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventByNameForIdeabookQuery__
 *
 * To run a query within a React component, call `useGetEventByNameForIdeabookQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByNameForIdeabookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByNameForIdeabookQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventByNameForIdeabookQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventByNameForIdeabookQuery, GetEventByNameForIdeabookQueryVariables>) {
  return ApolloReactHooks.useQuery<GetEventByNameForIdeabookQuery, GetEventByNameForIdeabookQueryVariables>(GetEventByNameForIdeabookDocument, baseOptions);
}
export function useGetEventByNameForIdeabookLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventByNameForIdeabookQuery, GetEventByNameForIdeabookQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetEventByNameForIdeabookQuery, GetEventByNameForIdeabookQueryVariables>(GetEventByNameForIdeabookDocument, baseOptions);
}
export type GetEventByNameForIdeabookQueryHookResult = ReturnType<typeof useGetEventByNameForIdeabookQuery>;
export type GetEventByNameForIdeabookLazyQueryHookResult = ReturnType<typeof useGetEventByNameForIdeabookLazyQuery>;
export type GetEventByNameForIdeabookQueryResult = Apollo.QueryResult<GetEventByNameForIdeabookQuery, GetEventByNameForIdeabookQueryVariables>;
export const CheckCanAccessPageDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CheckCanAccessPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventPageType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firebaseId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'firebaseCreateAt' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeSession' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'canAccessPage' },
                        arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'type' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } } }],
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  arguments: [
                    { kind: 'Argument', name: { kind: 'Name', value: 'type' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } } },
                    { kind: 'Argument', name: { kind: 'Name', value: 'normalized' }, value: { kind: 'BooleanValue', value: false } },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'private' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'page' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageTitle' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCheckCanAccessPageQuery__
 *
 * To run a query within a React component, call `useCheckCanAccessPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCanAccessPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCanAccessPageQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCheckCanAccessPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckCanAccessPageQuery, CheckCanAccessPageQueryVariables>) {
  return ApolloReactHooks.useQuery<CheckCanAccessPageQuery, CheckCanAccessPageQueryVariables>(CheckCanAccessPageDocument, baseOptions);
}
export function useCheckCanAccessPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckCanAccessPageQuery, CheckCanAccessPageQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<CheckCanAccessPageQuery, CheckCanAccessPageQueryVariables>(CheckCanAccessPageDocument, baseOptions);
}
export type CheckCanAccessPageQueryHookResult = ReturnType<typeof useCheckCanAccessPageQuery>;
export type CheckCanAccessPageLazyQueryHookResult = ReturnType<typeof useCheckCanAccessPageLazyQuery>;
export type CheckCanAccessPageQueryResult = Apollo.QueryResult<CheckCanAccessPageQuery, CheckCanAccessPageQueryVariables>;
export const GetEventByEventIdForEventRedirectDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventByEventIdForEventRedirect' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firebaseId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'website' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventByEventIdForEventRedirectQuery__
 *
 * To run a query within a React component, call `useGetEventByEventIdForEventRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByEventIdForEventRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByEventIdForEventRedirectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventByEventIdForEventRedirectQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventByEventIdForEventRedirectQuery, GetEventByEventIdForEventRedirectQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetEventByEventIdForEventRedirectQuery, GetEventByEventIdForEventRedirectQueryVariables>(GetEventByEventIdForEventRedirectDocument, baseOptions);
}
export function useGetEventByEventIdForEventRedirectLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventByEventIdForEventRedirectQuery, GetEventByEventIdForEventRedirectQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetEventByEventIdForEventRedirectQuery, GetEventByEventIdForEventRedirectQueryVariables>(
    GetEventByEventIdForEventRedirectDocument,
    baseOptions,
  );
}
export type GetEventByEventIdForEventRedirectQueryHookResult = ReturnType<typeof useGetEventByEventIdForEventRedirectQuery>;
export type GetEventByEventIdForEventRedirectLazyQueryHookResult = ReturnType<typeof useGetEventByEventIdForEventRedirectLazyQuery>;
export type GetEventByEventIdForEventRedirectQueryResult = Apollo.QueryResult<GetEventByEventIdForEventRedirectQuery, GetEventByEventIdForEventRedirectQueryVariables>;
export const GetEventForAdminMenuDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventForAdminMenu' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventInfoFragment' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'altTag' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatar' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventInfoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fianceeLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'greeting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tentativeDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'finalizedDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'timeString' },
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'timeFormat' }, value: { kind: 'EnumValue', value: 'time' } }],
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dateV0918' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventForAdminMenuQuery__
 *
 * To run a query within a React component, call `useGetEventForAdminMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventForAdminMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventForAdminMenuQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventForAdminMenuQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventForAdminMenuQuery, GetEventForAdminMenuQueryVariables>) {
  return ApolloReactHooks.useQuery<GetEventForAdminMenuQuery, GetEventForAdminMenuQueryVariables>(GetEventForAdminMenuDocument, baseOptions);
}
export function useGetEventForAdminMenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventForAdminMenuQuery, GetEventForAdminMenuQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetEventForAdminMenuQuery, GetEventForAdminMenuQueryVariables>(GetEventForAdminMenuDocument, baseOptions);
}
export type GetEventForAdminMenuQueryHookResult = ReturnType<typeof useGetEventForAdminMenuQuery>;
export type GetEventForAdminMenuLazyQueryHookResult = ReturnType<typeof useGetEventForAdminMenuLazyQuery>;
export type GetEventForAdminMenuQueryResult = Apollo.QueryResult<GetEventForAdminMenuQuery, GetEventForAdminMenuQueryVariables>;
export const GetEventFeatureFlagsByEventHandleDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventFeatureFlagsByEventHandle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featureFlags' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventFeatureFlagsByEventHandleQuery__
 *
 * To run a query within a React component, call `useGetEventFeatureFlagsByEventHandleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventFeatureFlagsByEventHandleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventFeatureFlagsByEventHandleQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventFeatureFlagsByEventHandleQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventFeatureFlagsByEventHandleQuery, GetEventFeatureFlagsByEventHandleQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetEventFeatureFlagsByEventHandleQuery, GetEventFeatureFlagsByEventHandleQueryVariables>(GetEventFeatureFlagsByEventHandleDocument, baseOptions);
}
export function useGetEventFeatureFlagsByEventHandleLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventFeatureFlagsByEventHandleQuery, GetEventFeatureFlagsByEventHandleQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetEventFeatureFlagsByEventHandleQuery, GetEventFeatureFlagsByEventHandleQueryVariables>(
    GetEventFeatureFlagsByEventHandleDocument,
    baseOptions,
  );
}
export type GetEventFeatureFlagsByEventHandleQueryHookResult = ReturnType<typeof useGetEventFeatureFlagsByEventHandleQuery>;
export type GetEventFeatureFlagsByEventHandleLazyQueryHookResult = ReturnType<typeof useGetEventFeatureFlagsByEventHandleLazyQuery>;
export type GetEventFeatureFlagsByEventHandleQueryResult = Apollo.QueryResult<GetEventFeatureFlagsByEventHandleQuery, GetEventFeatureFlagsByEventHandleQueryVariables>;
export const GetEventForAdminMenuV2Document = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventForAdminMenuV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'firebaseCreateAt' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventInfoFragment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventPassword' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventOnboarding' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'shouldShowOnboardingSurvey' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'productVerticals' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optOutOfGuestList' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optOutOfInvites' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optOutOfRegistry' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optOutOfWebsite' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pages' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPageContainer' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'timestamp' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageSlug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageTitle' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'altTag' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recommendation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'registryOnboardingSurvey' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastUpdatedAt' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'dateString' } }] },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'checklist' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventDesign' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'purpose' }, value: { kind: 'EnumValue', value: 'live' } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'font' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activeWebsiteHeaderPresentationLayout' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsiteHeaderPresentationSettings' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatar' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventInfoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fianceeLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'greeting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tentativeDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'finalizedDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'timeString' },
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'timeFormat' }, value: { kind: 'EnumValue', value: 'time' } }],
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dateV0918' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsiteHeaderPresentationSettings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsiteHeaderPresentationSettings' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dataJSON' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteLayout' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventForAdminMenuV2Query__
 *
 * To run a query within a React component, call `useGetEventForAdminMenuV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetEventForAdminMenuV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventForAdminMenuV2Query({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventForAdminMenuV2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventForAdminMenuV2Query, GetEventForAdminMenuV2QueryVariables>) {
  return ApolloReactHooks.useQuery<GetEventForAdminMenuV2Query, GetEventForAdminMenuV2QueryVariables>(GetEventForAdminMenuV2Document, baseOptions);
}
export function useGetEventForAdminMenuV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventForAdminMenuV2Query, GetEventForAdminMenuV2QueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetEventForAdminMenuV2Query, GetEventForAdminMenuV2QueryVariables>(GetEventForAdminMenuV2Document, baseOptions);
}
export type GetEventForAdminMenuV2QueryHookResult = ReturnType<typeof useGetEventForAdminMenuV2Query>;
export type GetEventForAdminMenuV2LazyQueryHookResult = ReturnType<typeof useGetEventForAdminMenuV2LazyQuery>;
export type GetEventForAdminMenuV2QueryResult = Apollo.QueryResult<GetEventForAdminMenuV2Query, GetEventForAdminMenuV2QueryVariables>;
export const SaveEventProductVerticalsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveEventProductVerticals' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateEventProductVerticalsPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveEventProductVerticals' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfGuestList' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfInvites' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfRegistry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfWebsite' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SaveEventProductVerticalsMutationFn = Apollo.MutationFunction<SaveEventProductVerticalsMutation, SaveEventProductVerticalsMutationVariables>;

/**
 * __useSaveEventProductVerticalsMutation__
 *
 * To run a mutation, you first call `useSaveEventProductVerticalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEventProductVerticalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEventProductVerticalsMutation, { data, loading, error }] = useSaveEventProductVerticalsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSaveEventProductVerticalsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SaveEventProductVerticalsMutation, SaveEventProductVerticalsMutationVariables>,
) {
  return ApolloReactHooks.useMutation<SaveEventProductVerticalsMutation, SaveEventProductVerticalsMutationVariables>(SaveEventProductVerticalsDocument, baseOptions);
}
export type SaveEventProductVerticalsMutationHookResult = ReturnType<typeof useSaveEventProductVerticalsMutation>;
export type SaveEventProductVerticalsMutationResult = Apollo.MutationResult<SaveEventProductVerticalsMutation>;
export type SaveEventProductVerticalsMutationOptions = Apollo.BaseMutationOptions<SaveEventProductVerticalsMutation, SaveEventProductVerticalsMutationVariables>;
export const GetEventAdminsAndInviteesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventAdminsAndInvitees' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventUsers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'auth0Id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emailIsVerified' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventAdminInvites' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'emailId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventAdminsAndInviteesQuery__
 *
 * To run a query within a React component, call `useGetEventAdminsAndInviteesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventAdminsAndInviteesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventAdminsAndInviteesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventAdminsAndInviteesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventAdminsAndInviteesQuery, GetEventAdminsAndInviteesQueryVariables>) {
  return ApolloReactHooks.useQuery<GetEventAdminsAndInviteesQuery, GetEventAdminsAndInviteesQueryVariables>(GetEventAdminsAndInviteesDocument, baseOptions);
}
export function useGetEventAdminsAndInviteesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventAdminsAndInviteesQuery, GetEventAdminsAndInviteesQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetEventAdminsAndInviteesQuery, GetEventAdminsAndInviteesQueryVariables>(GetEventAdminsAndInviteesDocument, baseOptions);
}
export type GetEventAdminsAndInviteesQueryHookResult = ReturnType<typeof useGetEventAdminsAndInviteesQuery>;
export type GetEventAdminsAndInviteesLazyQueryHookResult = ReturnType<typeof useGetEventAdminsAndInviteesLazyQuery>;
export type GetEventAdminsAndInviteesQueryResult = Apollo.QueryResult<GetEventAdminsAndInviteesQuery, GetEventAdminsAndInviteesQueryVariables>;
export const GetEventHandleAvailabilityDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventHandleAvailability' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'websiteHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isWebsiteHandleAvailable' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'websiteHandle' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'websiteHandle' } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventHandleAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetEventHandleAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventHandleAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventHandleAvailabilityQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      websiteHandle: // value for 'websiteHandle'
 *   },
 * });
 */
export function useGetEventHandleAvailabilityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventHandleAvailabilityQuery, GetEventHandleAvailabilityQueryVariables>) {
  return ApolloReactHooks.useQuery<GetEventHandleAvailabilityQuery, GetEventHandleAvailabilityQueryVariables>(GetEventHandleAvailabilityDocument, baseOptions);
}
export function useGetEventHandleAvailabilityLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventHandleAvailabilityQuery, GetEventHandleAvailabilityQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetEventHandleAvailabilityQuery, GetEventHandleAvailabilityQueryVariables>(GetEventHandleAvailabilityDocument, baseOptions);
}
export type GetEventHandleAvailabilityQueryHookResult = ReturnType<typeof useGetEventHandleAvailabilityQuery>;
export type GetEventHandleAvailabilityLazyQueryHookResult = ReturnType<typeof useGetEventHandleAvailabilityLazyQuery>;
export type GetEventHandleAvailabilityQueryResult = Apollo.QueryResult<GetEventHandleAvailabilityQuery, GetEventHandleAvailabilityQueryVariables>;
export const GetUrlVerificationStatusDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUrlVerificationStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifyUrl' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'url' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'url' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetUrlVerificationStatusQuery__
 *
 * To run a query within a React component, call `useGetUrlVerificationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUrlVerificationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUrlVerificationStatusQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useGetUrlVerificationStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUrlVerificationStatusQuery, GetUrlVerificationStatusQueryVariables>) {
  return ApolloReactHooks.useQuery<GetUrlVerificationStatusQuery, GetUrlVerificationStatusQueryVariables>(GetUrlVerificationStatusDocument, baseOptions);
}
export function useGetUrlVerificationStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUrlVerificationStatusQuery, GetUrlVerificationStatusQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetUrlVerificationStatusQuery, GetUrlVerificationStatusQueryVariables>(GetUrlVerificationStatusDocument, baseOptions);
}
export type GetUrlVerificationStatusQueryHookResult = ReturnType<typeof useGetUrlVerificationStatusQuery>;
export type GetUrlVerificationStatusLazyQueryHookResult = ReturnType<typeof useGetUrlVerificationStatusLazyQuery>;
export type GetUrlVerificationStatusQueryResult = Apollo.QueryResult<GetUrlVerificationStatusQuery, GetUrlVerificationStatusQueryVariables>;
export const FindDefaultThingsToDoPageDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FindDefaultThingsToDoPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'findDefaultThingsToDoPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payload' },
                value: {
                  kind: 'ObjectValue',
                  fields: [{ kind: 'ObjectField', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFindDefaultThingsToDoPageQuery__
 *
 * To run a query within a React component, call `useFindDefaultThingsToDoPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDefaultThingsToDoPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindDefaultThingsToDoPageQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useFindDefaultThingsToDoPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FindDefaultThingsToDoPageQuery, FindDefaultThingsToDoPageQueryVariables>) {
  return ApolloReactHooks.useQuery<FindDefaultThingsToDoPageQuery, FindDefaultThingsToDoPageQueryVariables>(FindDefaultThingsToDoPageDocument, baseOptions);
}
export function useFindDefaultThingsToDoPageLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindDefaultThingsToDoPageQuery, FindDefaultThingsToDoPageQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<FindDefaultThingsToDoPageQuery, FindDefaultThingsToDoPageQueryVariables>(FindDefaultThingsToDoPageDocument, baseOptions);
}
export type FindDefaultThingsToDoPageQueryHookResult = ReturnType<typeof useFindDefaultThingsToDoPageQuery>;
export type FindDefaultThingsToDoPageLazyQueryHookResult = ReturnType<typeof useFindDefaultThingsToDoPageLazyQuery>;
export type FindDefaultThingsToDoPageQueryResult = Apollo.QueryResult<FindDefaultThingsToDoPageQuery, FindDefaultThingsToDoPageQueryVariables>;
